import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=6ecb9b51&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=6ecb9b51&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecb9b51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ecb9b51')) {
      api.createRecord('6ecb9b51', component.options)
    } else {
      api.reload('6ecb9b51', component.options)
    }
    module.hot.accept("./orderDetail.vue?vue&type=template&id=6ecb9b51&scoped=true", function () {
      api.rerender('6ecb9b51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/sub-merchant/components/content/payment-link/components/tabs/orderDetail.vue"
export default component.exports